/*
 * @FileAuthor: ghy
 * @Date: 2023-09-20 17:49:17
 * @Description: 事件类型
 */

const Event = {
  // 指南针相关事件可以在这里添加
};

module.exports = Event;
